import { Button } from 'antd';
import * as React from 'react';
import styles from './assets/buttonStyles.scss';
import { IButtonClickEventArgs, IButtonProps, IButtonSizes } from './entities';

import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const BCButton = (props: IButtonProps) => {
	styles;

	const onClick = (e: React.FormEvent<any>) => {
		props.onClick?.({
			event: e,
			data: {
				guid: props.guid,
				size: props.size,
				text: props.text,
				type: props.type
			}
		});
	};

	const onDoubleClick = (e: React.FormEvent<any>) => {
		props.onDoubleClick?.({
			event: e,
			data: {
				guid: props.guid,
				size: props.size,
				text: props.text,
				type: props.type
			}
		});
	};

	const onMouseEnter = (e: React.FormEvent<any>) => {
		props.onMouseEnter?.({
			event: e
		});
	};

	const onMouseLeave = (e: React.FormEvent<any>) => {
		props.onMouseLeave?.({
			event: e
		});
	};

	const onFocus = (e: React.FormEvent<any>) => {
		props.onFocus?.({
			event: e
		});
	};

	const onBlur = (e: React.FormEvent<any>) => {
		props.onBlur?.({
			event: e
		});
	};

	const {
		size,
		children,
		cssClass,
		className,
		danger,
		ghost,
		disabled,
		icon,
		text,
		type,
		title,
		tabIndex,
		href,
		id,
		shape,
		ref,
		buttonRef,
		block,
		style,
		loading,
		seleniumId,
		htmlType
	} = props;

	const buttonClassNames = cx({
		[cssClass]: cssClass ? true : false,
		[className]: className ? true : false
	});

	return (
		<Button
			href={href}
			tabIndex={tabIndex}
			title={title}
			size={size}
			style={style}
			className={buttonClassNames}
			disabled={disabled}
			icon={icon}
			onClick={onClick}
			onDoubleClick={onDoubleClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			onFocus={onFocus}
			loading={loading}
			type={type}
			id={id}
			shape={shape}
			ref={buttonRef || ref}
			danger={danger}
			block={block}
			ghost={ghost}
			onBlur={onBlur}
			data-selenium-id={seleniumId}
			htmlType={htmlType}
		>
			{children || text}
		</Button>
	);
};

export default BCButton;
export { IButtonClickEventArgs, IButtonProps, IButtonSizes };
